import { ng } from "@common/ngds";

export const DEFAULT_FIRE_DURATION_MINUTES = 60;
export const FIRE_DURATION_OPTIONS = [30, 60, 90, 120, 180, 240] as const;

export function hasFireCombination(project: any): boolean {
  const combinations = project?.data?.data?.input?.structures?.[0]?.loading?.combinations ?? [];
  return combinations.some((lc: any) => {
    const type =
      lc?.type != null ? ng.loadcombination.Type_FromObject(lc.type) : ng.loadcombination.Type.TYPE_UNSPECIFIED;
    return type === ng.loadcombination.Type.TYPE_FIRE;
  });
}

// Which thicknesses a timber fire protection material is described by: the single-layer materials
// carry one "fire protection thickness", the two-layer ones an inner and an outer one, and the
// remaining types (user defined, none) none at all — a user-defined protection is described by its
// charring parameters instead. Shared so the fire settings inputs and the design review agree on
// which quantities a given material even has.
const SINGLE_LAYER_TIMBER_PROTECTIONS: ng.fire_protection.timber.MaterialType[] = [
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_WOOD,
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH1_INTERNAL,
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH1_OTHER,
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F1_INTERNAL,
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F1_OTHER,
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_ROCK_FIBER,
];

const TWO_LAYER_TIMBER_PROTECTIONS: ng.fire_protection.timber.MaterialType[] = [
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH2_INTERNAL,
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_AH2_OTHER,
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F2_INTERNAL,
  ng.fire_protection.timber.MaterialType.MATERIAL_TYPE_GYPSUM_BOARD_F2_OTHER,
];

/** Whether a timber protection material is described by a single fire protection thickness. */
export const timberProtectionHasThickness = (mtrlType: ng.fire_protection.timber.MaterialType): boolean =>
  SINGLE_LAYER_TIMBER_PROTECTIONS.includes(mtrlType);

/** Whether a timber protection material is described by an inner and an outer layer thickness. */
export const timberProtectionHasLayerThicknesses = (mtrlType: ng.fire_protection.timber.MaterialType): boolean =>
  TWO_LAYER_TIMBER_PROTECTIONS.includes(mtrlType);
